var GATEWAY = process.env.VUE_APP_GATEWAY;

var GETINGOT = process.env.VUE_APP_GETINGOT;

/* #region 原始接口  */
var BaseUrl = process.env.VUE_APP_BASEURL;
var DiscernUrl = `${BaseUrl}`;
var BI = process.env.VUE_APP_BI;
var User = process.env.VUE_APP_USER;
var Express = process.env.VUE_APP_EXPRESS;
var Commodity = process.env.VUE_APP_COMMODITY;
var cms = process.env.VUE_APP_CMS;
var Wallet = process.env.VUE_APP_WALLET;
/* #endregion  */

/* #region [gateway]接口  */
if (process.env.VUE_APP_MIDDLEWARE === 'gateway') {
  BaseUrl = `${GATEWAY}/card`;
  DiscernUrl = `${GATEWAY}/discern`;
  BI = `${GATEWAY}/bi`;
  User = `${GATEWAY}/user`;
  Express = `${GATEWAY}/express`;
  Commodity = `${GATEWAY}/commodity`;
  cms = `${GATEWAY}/cms`;
  Wallet = `${GATEWAY}/wallet`;
}
/* #endregion */

const api = {
  /*COS Token*/
  costoken: BaseUrl + "/NewCommodity/gettoken", //COS Token

  GetAllNationIcons: cms + "/api/NationIcon/GetAllNationIcons", // get 全部国家图标地址

  /*用户相关*/
  GetTokenAuth: User + "/api/Auth/GetToken", //POST 获取token
  // SignIn: User + "/api/Member/SignIn", //POST 登录
  SignIn: User + "/api/Member/NewSignIn", //新登录 
  GetMemberInfo: User + "/api/Member/GetMemberInfo", //通过用户id获取用户详情
  MemberDetail: BaseUrl + "/member/detail", //获取用户信息
  ForeignRegister: User + "/api/Member/ForeignRegister", //POST 国外注册
  ResetPassword: User + "/api/Member/ResetPassword", //POST 邮箱重置密码
  SendEmail: User + "/api/Member/SendEmail", //POST 向邮箱发送验证码
  VerifyeEmail: User + "/api/Member/VerifyeEmail", //验证Email
  VerifyNickName: User + "/api/Member/VerifyNickName", //验证昵称
  GetNewServiceAgreements:
    User + "/api/ServiceAgreement/GetNewServiceAgreements", //通过类型获取国外有效合规文档
    
  GetBlackList: BaseUrl + "/Member/MyBlacklist", //黑名单-获取我的黑名单记录
  OperateBlack: BaseUrl + "/Member/OperateBlacklist", //POST 加入/取消黑名单

  GetExpressShipper: Express + "/api/ExpressShipper/GetExpressShipper",

  //GetToken: BaseUrl + "/api/Authenticatin/GetToken", //POST 卖家获取token

  /*汇率转换*/
  GetUSD: BaseUrl + "/NewMyCommodity/GetUSD", //获取汇率
  GetExchangeRate: BaseUrl + "/NewMyCommodity/GetExchangeRate", //GET 获取汇率 memberSource

  /*消息管理*/
  NotificationCount: BaseUrl + "/Notification/NotificationCount", //获取消息未读数
  MsgDetail: BaseUrl + "/Notification/Detail", //消息详情
  MyNotificationForWeb: BaseUrl + "/Notification/MyNotificationForWeb", //消息二级列表_web专用
  SetRead: BaseUrl + "/Notification/SetRead", //POST 标记消息已读
  SetAllRead: BaseUrl + "/Notification/SetReads", //POST 标记全部消息已读
  DeleteMessgaes: BaseUrl + "/Notification/DeleteMessgaes", //POST 删除消息 Ids=1&Ids=2
  ComplaintsAdd: BaseUrl + "/Complaints/Add", //POST 投诉聊天对象

  /* 维权 */
  GetSafeRights: BaseUrl + "/Orders/GetSafeRights", //获取维权的申诉列表
  AddSafeRight: BaseUrl + "/Orders/AddSafeRight", //POST 申请维权
  ReOpenSafeRight: BaseUrl + "/Orders/ReOpenSafeRight", //再次申请维权
  CancelSafrRight: BaseUrl + "/Orders/CancelSafrRight", //POST 取消维权
  AppealSafrRight: BaseUrl + "/Orders/AppealSafrRight", //申诉维权
  GetPlanSRResultByOrderId: BaseUrl + "/Orders/GetPlanSRResultByOrderId", //获取卡淘维权预处理详情通过id
  ModityPlanSRResultAddress:BaseUrl + "/Orders/ModityPlanSRResultAddress", //POST 维权预处理卖家上传收货地址
  ConfirmPlanSRResult:BaseUrl + "/Orders/ConfirmPlanSRResult", //POST 维权预处理卖家确认退款
  PlanSRAddressEdit: BaseUrl + "/Orders/PlanSRAddressEdit", //通过用户id获取预维权卖家退货地址

  /*统计*/
  GetSellerDaySales: BI + "/api/SellerSale/GetSellerDaySales", //卖家日销售统计
  GetSellerMonthSales: BI + "/api/SellerSale/GetSellerMonthSales", //卖家月销售统计
  GetSellerData: BI + "/api/SellerSale/GetSellerData", //卖家商品统计
  ExportOrderReport: BI + "/api/SellerSale/ExportOrderReport", //报表、对账单下载 OrderReportType 1：下载订单报表 2、下载对账单
  ExportTimeCheck: BI + "/api/SellerSale/ExportTimeCheck", //卖家数据导出检查
  GetCommodityStatistics: BaseUrl + "/NewStatistics/GetCommodityStatistics", //商品数量统计
  GetOrderStatistics: BaseUrl + "/NewStatistics/GetOrderStatistics", //待发货订单统计,商品议价统计
  GetStoreStatistics: BaseUrl + "/NewStatistics/GetStoreStatistics", //店铺关注数、好评率统计

  /*商品录入*/
  GetNewCommodityById: BaseUrl + "/NewCommodity/GetNewCommodityById", //GET id, memberId 根据商品Id获取商品信息及运费信息
  GetCategories: BaseUrl + "/NewCommodity/GetCommodityCategories", //GET 获取商品类目及属性
  GetKeyValue: BaseUrl + "/NewCommodity/GetKeyValueByPropertyId", //GET 根据属性Id获取对应key-value ?propertyId=1
  GetChinaArea: BaseUrl + "/NewCommodity/GetAmericaArea", //GET 获取海外州
  GetAreasByCode: User + "/api/Area/GetAreasByCode",//GET 根据code获取区域
  GetCommodityProperties: BaseUrl + "/NewCommodity/GetCommodityProperties", //获取商品属性 ?id=
  SaveCommodity: BaseUrl + "/NewCommodity/SaveCommodity", //POST 保存商品
  SaveDraftCommodity: BaseUrl + "/NewCommodity/SaveDraftCommodity", //POST 保存商品草稿
  /*评价卡录入*/
  GetNewCommodityByCode: BaseUrl + '/NewCommodity/GetNewCommodityByCode',//根据验货报告Code获取卡片信息
  GetNewCommodityByCodeScore: BaseUrl + '/NewCommodity/GetNewCommodityByCodeScore',//根据验货报告Code获取卡的评分信息
  
  /*盖高 AI识别 录入*/
  GetingotDiscern: DiscernUrl + '/PicUpLoadEx/UpLoadImg',//识卡接口 [POST]

  /*草稿*/
  GetCommodityById: BaseUrl + "/NewCommodity/GetCommodityById", //GET 商品草稿-详细
  GetCommodityByPage: BaseUrl + "/NewCommodity/GetCommodityByPage", //GET 商品草稿-列表
  DeleteDraftCommodity: BaseUrl + "/NewCommodity/DeleteDraftCommodity", //POST 删除商品草稿 [string id]

  /*商品*/
  DetailCommodity: BaseUrl + "/Commodity/DetailCommodity", // 获取商品详情
  GetCommodityTitleRuleByThirdCategoryId:
    Commodity +
    "/api/CommodityTitleRule/GetCommodityTitleRuleByThirdCategoryId", //获取商品标题规则

  GetKeyValueByThirdCategoryId:
    BaseUrl + "/NewCommodity/GetKeyValueByThirdCategoryId", //三级类目id获取属性以及对应的key-value ?thirdCategoryId=1
  SearchCommodity: BaseUrl + "/NewCommodity/SearchCommodity", //商品收搜userId, pageIndex, pageSize, searchKey, searchJson, sort, sortType

  SearchMyCommodities: BaseUrl + "/NewMyCommodity/SearchMyCommodities", // 我的 商品列表
  Bid: BaseUrl + "/NewMyCommodity/Bid", // 我收到的议价 列表
  GetCommodityShipment: BaseUrl + "/NewMyCommodity/GetCommodityShipment", //获取指定商品运费模板

  ReleaseCommodity: BaseUrl + "/NewMyCommodity/ReleaseCommodities", //POST 发布商品信息
  Delete: BaseUrl + "/NewMyCommodity/Delete", //POST删除商品

  /*下架*/
  Revocation: BaseUrl + "/Commodity/Revocation", //POST 下架卡片
  Offline: BaseUrl + "/Commodity/Offline", //POST 下架卡片 申请
  GetOffline: BaseUrl + "/NewMyCommodity/GetOffline", //获取下架申请的状态

  /*议价*/
  BargainIndex: BaseUrl + "/Bargain/Index", //出价历史/商品议价信息
  BargainAdd: BaseUrl + "/Bargain/Add", //POST 添加议价消息
  Approve: BaseUrl + "/Bargain/Approve", //POST 同意对方议价
  Refuse: BaseUrl + "/Bargain/Refuse", //POST 直接拒绝议价

  /*订单*/
  GetSellStatistics: BaseUrl + "/NewMyOrder/GetSellStatistics", //卖家订单统计
  SearchSellOrders: BaseUrl + "/NewMyOrder/SearchSellOrders", //卖家订单查询
  OrderDetail: BaseUrl + "/NewOrder/Detail", //订单详情
  ModifyPostage: BaseUrl + "/Orders/ModifyPostage/", //POST 修改邮费
  SetExpress: BaseUrl + "/Orders/SetExpress", //POST 修改快递信息 /设置订单快递信息
  Appraisal: BaseUrl + "/Orders/Appraisal", //POST 评价 / 添加订单评价
  AppraisalList: BaseUrl + "/NewOrder/AppraisalList", //评价历史
  GetOrderCheck: BaseUrl + "/NewOrderCheck/GetOrderCheckByOrderId", //通过订单id获取订单验收详情
  MergeOrders: BaseUrl + "/NewMyOrder/MergeOrders", //卖家获取买家可合并订单列表
  SaveMergePreview: BaseUrl + "/NewMyOrder/PreviewMergeOrders", //卖家合并订单预览[弃用，改用 SaveMergePreviewPost]
  SaveMergePreviewPost: BaseUrl + "/NewMyOrder/PreviewMergeOrdersPost", //POST 卖家合并订单预览
  SubmitMergeOrders: BaseUrl + "/NewMyOrder/SubmitMergeOrders", //POST 合并订单
  RestoreOrder: BaseUrl + "/NewMyOrder/RestoreOrder", //拆分订单
  GetOrderAddress: BaseUrl + "/NewMyOrder/GetOrderAddress", //卖家查海外订单收货地址
  OpenOrder: BaseUrl + "/NewOrder/OpenOrder", //鸽子订单重新开启
  CloseOrder: BaseUrl + "/NewMyCommodity/OrderClose", //卖家关闭订单

  /*商铺信息*/
  EditStore: User + "/api/Store/EditStore", //POST 编辑商铺信息
  EditStoreShipment: User + "/api/Store/EditStoreShipment", //POST 保存发货地
  GetStores: BaseUrl + "/NewMember/GetStores", //获取商铺信息 列表
  SyncStore: BaseUrl + "/NewMember/SyncStore", //POST 同步海外用户商铺信息

  /*运费模板*/
  GetMemberAddress: BaseUrl + "/MemberAddress/GetMemberAddress", //获取快递模板信息
  SaveInfoAddress: BaseUrl + "/MemberAddress/SaveInfo", //POST 保存快递模板信息

  /* 钱包 */
  GetAccountInfo: Wallet + "/api/Wallet/GetAccountInfo", // 获取账户信息（余额）
  TakeCash: Wallet + "/api/Wallet/TakeCash", // 用户提现
  GetRecordByPage: Wallet + "/api/Wallet/GetRecordByPage", // 获取用户流水记录【用户】
  GetRecordByMemberForExport: Wallet + "/api/Wallet/GetRecordByMemberForExport", // 导出流水数据
};
export default api;

export const GETINGOT_API = {
  /*盖高 AI识别 录入*/
  GetingotUpload: GETINGOT + '/discern/image/upload',//上传图片 [POST]
  GetingotV2: GETINGOT + '/discern/v2',//识卡接口 [POST]
};



// WEBPACK FOOTER //
// ./src/api/api.js